var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.7 86.9",
    style: {
      enableBackground: "new 0 0 86.7 86.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);stroke:#818082;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:#818082;}\n\t.st2{font-family:'Montserrat-SemiBold';}\n\t.st3{font-size:28px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1,
    y1: 812.9491,
    x2: 85.6945,
    y2: 812.9491,
    gradientTransform: "matrix(1 0 0 1 0 -769.53)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD1D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#C9CBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#B9BBBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#9EA0A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E9092"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.5,38.8c-0.2-1.3-0.7-1.8-2-1.9l-4.7-0.3c-1.3-0.1-2.1-0.8-2.4-2v-0.3L73,25.9c1.3-1.4,2.8-2.9,4.4-4.5 c1-1.1,1.2-1.7,0.3-2.9c-2-2.8-4.3-5.2-6.8-7.4c-0.4-0.4-0.9-0.6-1.4-0.9c-0.7-0.4-1.6-0.3-2.2,0.3c-1.7,1.5-3.4,2.9-4.8,4.2 L52,10V3.5c0.1-1-0.6-1.8-1.6-1.9C46.7,1,42.9,0.8,39.1,1.2c-1,0-1.9,0.8-1.9,1.9C37.1,5,36.8,7.1,36.8,9c0,0.7-0.3,0.9-1,1.1 c-0.8,0.1-1.6,0.4-2.4,0.7l-7.3,2.9l-4.9-4.7c-0.5-0.7-1.5-0.9-2.1-0.4c-3.2,2.3-6.2,5-8.7,8.1c-0.7,0.8-0.6,1.9,0.1,2.6 c0.6,0.7,1.3,1.4,1.9,2.2l2.5,3c-1.9,2.9-3.3,6-4.3,9.2c-0.1,0.6-0.6,1-1.1,0.9c-1.9,0-3.8,0-5.8,0.1c-1.5,0-2.1,0.5-2.2,1.9 c-0.2,2.9-0.4,5.9-0.5,8.9c0,0.9,0.2,1.8,0.4,2.6c0.2,0.9,1,1.4,1.9,1.4c1.9,0,3.9,0.3,5.9,0.5c0.4,0,0.8,0.3,0.8,0.8l0,0 c0.1,0.8,0.4,1.6,0.6,2.3c0.9,2.5,1.9,5,3,7.5l-4.6,4.7c-0.8,0.6-1,1.6-0.4,2.4c0.1,0.1,0.1,0.2,0.2,0.3c2.1,3,4.7,5.8,7.5,8.1 c0.7,0.8,1.9,0.9,2.7,0.2c0.1-0.1,0.2-0.2,0.2-0.2c1.5-1.3,3.1-2.6,4.6-3.9c0.3-0.3,0.7-0.3,1,0l0,0c2.8,1.8,5.8,3.1,8.9,4.1 c0.5,0.2,0.7,0.3,0.7,0.9c0,2.1,0,4.2,0.1,6.3c-0.1,0.9,0.5,1.8,1.5,1.9c0,0,0.1,0,0.1,0c3.7,0.6,7.5,0.7,11.3,0.3 c1,0.1,1.9-0.7,2-1.8v-0.3c0.1-1.9,0.2-3.9,0.4-5.8c0.1-0.4,0.3-0.7,0.6-0.9c3.4-0.8,6.7-2.1,9.8-3.8c0.5,0.4,0.9,0.8,1.3,1.2 c1.3,1.2,2.5,2.4,3.8,3.6c0.6,0.8,1.6,0.9,2.4,0.3c0.1-0.1,0.2-0.2,0.3-0.3c1.8-1.4,3.5-2.8,5.1-4.4c1.1-1,2.1-2.2,2.9-3.4 c0.7-1.1,0.6-1.7-0.3-2.7c-1.3-1.4-2.6-2.9-3.8-4.4c-0.2-0.3-0.2-0.6-0.1-0.9c1.7-2.8,3.1-5.9,4.1-9.1c0.1-0.3,0.4-0.5,0.7-0.5 c2-0.1,4-0.1,6-0.2c1.4,0,2.1-0.5,2.2-1.9c0.2-2.3,0.4-4.5,0.5-6.8C85.7,41.8,85.7,40.3,85.5,38.8L85.5,38.8L85.5,38.8z  M42.6,68.4c-13.9-0.4-24.9-12-24.5-25.9s12-24.9,25.9-24.5s24.8,12,24.5,25.9v0C68.1,57.9,56.5,68.9,42.6,68.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(266.41 150.2)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -237.0375 -98.9079)",
    className: "st1 st2 st3"
  }, "M"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearM);
export default __webpack_public_path__ + "static/media/gear-m.e4537fbf740a0df89e39d60453401e69.svg";
export { ForwardRef as ReactComponent };